{
  "title": "Raportează o problemă",
  "close": "Închide",
  "minimize": "Minimizează",
  "restore": "Înapoi la tichet",
  "ticketTitle": "Rezumat",
  "titlePlaceholder": "Într-o linie: ce nu a funcționat?",
  "category": "Tip",
  "description": "Ce s-a întâmplat?",
  "descriptionPlaceholder": "Ce încercai să faci și ce te așteptai să se întâmple?",
  "phiHint": "Datele de identificare ale pacienților sunt eliminate automat înainte de salvare.",
  "contextTitle": "Atașat automat",
  "contextScreen": "Ecran",
  "contextFailedRequests": "Cereri eșuate recent",
  "contextVersion": "Versiune aplicație",
  "submit": "Trimite",
  "myTickets": "Tichetele mele",
  "submitted": "Tichet trimis",
  "submittedDetail": "Tichetul tău este {{publicRef}}. Echipa de suport va reveni.",
  "submitFailed": "Tichetul nu a putut fi trimis",
  "submitFailedDetail": "Încearcă din nou. Dacă eroarea persistă, contactează direct suportul.",
  "screenshot": "Captură de ecran (opțional)",
  "attachScreenshot": "Atașează un PNG",
  "screenshotHint": "Doar PNG, maximum 5 MB. Orice imagine trece prin pasul de anonimizare înainte de a fi atașată.",
  "attachmentTypeError": "Se pot atașa doar fișiere PNG.",
  "attachmentSizeError": "Fișierul depășește 5 MB.",
  "attachmentFailed": "Tichetul a fost trimis, captura nu",
  "attachmentFailedDetail": "Tichetul {{publicRef}} a fost creat. Poți atașa captura din Tichetele mele.",
  "takeScreenshot": "Capturează ecranul",
  "capturing": "Se capturează…",
  "captureUnsupported": "Acest browser nu poate captura ecranul. Atașează un fișier PNG.",
  "captureBlockedByImage": "O imagine din pagină a blocat captura. Fă o captură cu instrumentul obișnuit și atașeaz-o.",
  "captureEmpty": "Captura a ieșit goală. Atașează un fișier PNG.",
  "captureFailed": "Ecranul nu a putut fi capturat. Atașează un fișier PNG.",
  "redactorTitle": "Acoperă datele pacientului",
  "redactorInstruction": "Trage cu mouse-ul peste orice identifică un pacient. Zonele negre sunt aplicate definitiv în imagine și nu mai pot fi anulate după atașare.",
  "redactorLoading": "Se pregătește imaginea…",
  "redactorFailed": "Imaginea nu a putut fi deschisă pentru anonimizare.",
  "redactedAreas": "Zone acoperite",
  "undoArea": "Anulează ultima",
  "clearAreas": "Șterge tot",
  "redactorAcknowledge": "Am acoperit toate datele de identificare ale pacientului din această imagine.",
  "applyAndAttach": "Atașează",
  "cancel": "Anulează"
}
